import { render } from "./AddEvent.vue?vue&type=template&id=c93cfa38&scoped=true"
import script from "./AddEvent.vue?vue&type=script&lang=js"
export * from "./AddEvent.vue?vue&type=script&lang=js"

import "./AddEvent.vue?vue&type=style&index=0&id=c93cfa38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c93cfa38"]])

export default __exports__